import React from 'react';

export const ProjectNotFound = () => {
	// EAX-448 New component
	return <p>Project not found</p>;
};
